<template lang="html">
  <div :class="{'img img-default': !model.image.url, 'img img-preview': model.image.url}">
    <span v-show="!image.url">Selecione uma imagem</span>
    <input type="file" @change="choseFile($event)" class="upload" :name="`model_${model.id}`"/>
    <div class="preview" v-if="image.url">
      <img :src="image.url" alt="" @change="choseFile($event)">
    </div>
  </div>
</template>

<script>
export default {
  name: 'upload-component',
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    image: {
      get() {
        if (this.model.image) {
          return this.model.image;
        }
        return { name: null, url: null };
      },
      set(value) {
        this.model.image = value;
        this.$emit('update:model', this.model);
      },
    },
  },
  components: {},
  methods: {
    choseFile(event) {
      const [file] = event.target.files;
      file.url = URL.createObjectURL(file);
      this.image = file;
    },
  },
};
</script>

<style lang="scss" scoped>

.img {
  width: 100%;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  &-default {
    border: 2px dashed #cccccc;
    background: #eeeeee;
    span {
        display: block;
        position: absolute;
    }
  }
}
input.upload {
    position: absolute;
    width: 100%;
    right: 0;
    z-index: 2;
    font-size: 100px; /* Aumenta tamanho do campo */
    opacity: 0;
    filter: alpha(opacity=0);
}

.preview {
  width: 100%;
  height: 210px;
  text-align: center;
  position: relative;
  img{
    max-width: 100%;
    width: auto;
    height: 100%;
  }
}
</style>
